<template>
    <div :style="isRedesigned ? '' : 'margin-top:50px;'" :class="{ footerRedesigned: isRedesigned }" role='contentinfo'>
        <!-- Need Help modal -->
        <modal v-show="needHelpVisible" @close="closeNeedHelpModal">
             <template v-slot:body>
            <div id='needHelpModal' ref='needHelpModal' tabindex="-1" ></div>
            </template>
        </modal>
        <modal v-show="complaintVisible" @close="closeComplaintModal">
             <template v-slot:body style='text-align:center;'>
            <br/><br/>
            <div  ref="complaintModal"  id="complaintModal" tabindex="-1"></div>
            </template>
        </modal>
        <div id='needHelpDiv' class='d-none d-lg-block d-print-none'><button @click='showNeedHelpModal()' class='btnHelp form-control'>{{$t('text.btn_needhelp')}}</button></div>

        <div id='footer'>
            <div class='row'>
                <div class='col d-none d-sm-block'></div>
                <div class='col-12 col-sm-10 col-lg-8'>
                    <div class='d-lg-none'><a href='javascript:void(0);' @click='showNeedHelpModal()' class='d-print-none footerLink'>{{$t('text.btn_needhelp')}}</a><br/><br/></div>
                  <p v-if='this.$store.state.site==="cibc"' class='footerText'><strong>{{$t('text.footer_partner')}}</strong></p>
                  <span class='footerText'>{{$t('text.footer0')}}</span><br/><br/>
                    <span style='margin-bottom: 25px; display:block;' v-if='this.$store.state.site==="cibc"&&this.$route.meta.page===8' class='footerText'>{{$t('text.footerAMF')}}</span>
                    <span v-if='this.$store.state.site==="cibc"' class='footerText footerDisclosure' v-html="$t('text.footer1')"></span><br/><br/>
                    <span v-if='this.$store.state.site==="cibc"' class='footerText'><a href='javascript:void(0)' @click='showComplaintModal()' id="footer1_complaint_link">{{$t('text.footer1_complaint_link')}}</a></span>
                    <span v-else class='footerText'>{{$t('text.footer1nm')}}</span>
                  <br/><br/>
                  <p class='footerText' v-html='$t("text.footer1b")'></p>
                  <p class='footerText' v-html='$t("text.footer1c")'></p>
                  <nav aria-label='footer'>
                    <div class='row d-print-none' style='padding-top:10px;'>
                        <ul style='padding-left:15px;'>
                            <li style='display:inline; margin-right: 40px;'>
                                <a v-if='this.$store.state.site==="cibc"' class="footerLink" href="javascript:void(0);" @click='openTooltip($t("text.viewCertificatePanel"))'>{{$t('text.footer_link4')}}</a>
                                <a v-else class="footerLink" href="javascript:void(0);" @click='openTooltip($t("text.viewCertificatePanelnm"))'>{{$t('text.footer_link4nm')}}</a>
                            </li>
                            <li style='display:inline'>
                                <a @click='OpenInNewWindow(url1)' class="footerLink" href="javascript:void(0);">{{$t('text.footer_link2')}}<span class='sr-only'>{{$t('text.openNewWindow')}}</span></a>
                            </li>
                        </ul>
                        <!--
                        <div class='col-6 col-sm-auto text-sm-center' style='min-width:70px;padding-bottom:10px; '>
                            <a v-if='this.$store.state.site==="cibc"' class="footerLink" href="javascript:void(0);" @click='openTooltip($t("text.viewCertificatePanel"))'>{{$t('text.footer_link4')}}</a>
                            <a v-else class="footerLink" href="javascript:void(0);" @click='openTooltip($t("text.viewCertificatePanelnm"))'>{{$t('text.footer_link4nm')}}</a>
                        </div>
                        <div class='col-6 col-sm-auto text-sm-center' style='min-width:70px;padding-bottom:10px;'><a @click='OpenInNewWindow(url1)' class="footerLink" href="javascript:void(0);">{{$t('text.footer_link2')}}<span class='sr-only'>{{$t('text.openNewWindow')}}</span></a></div>
                        -->
                    </div>
                    </nav>
                </div>
                <div class='col d-none d-sm-block'></div>
            </div>
        </div>
    </div>
</template>

<script>
import modal from "../components/Modal.vue";
import bus from "../utils/bus.js";

export default {
  components: {
    modal,
  },
  data() {
    return {
      needHelpVisible: false,
      complaintVisible: false,
    }
  },
  computed: {
    isRedesigned() {
      return this.$route.meta.redesigned === true;
    },
    url1() {
        let pathInsert="";
        const pathArray=window.location.pathname.split("/");
        if(pathArray[1]==="cibc"||pathArray[2]==="cibc"||pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibc"}
        return (
            window.location.origin +
            pathInsert + 
            "/assets/documents/" +
            this.$t("text.link_privacy")
        );
    }
  },
  methods: {
    OpenInNewWindow(url, width, height) {
      const popupWidth = width == null ? 500 : width;
      const popupHeight = height == null ? 600 : height;
      window.open(
        url,
        "popup",
        "scrollbars=1,resizable=1,width=" +
          popupWidth +
          ",height=" +
          popupHeight
      );
    },
    showNeedHelpModal() {
        let phoneLink;
        if(this.$store.state.site==="cibc") {
            phoneLink=`<a href="tel:+18002819109" class='phoneLink'>1-800-281-9109</a>`;
        } else {
            phoneLink=`<a href="tel:+18338615088" class='phoneLink'>1-833-861-5088</a>`;
        }
        document.getElementById("needHelpModal").innerHTML=`
            <div class='row'>
                <div class='col-12' style='text-align:center;'>
                    <h1 class='textNeedHelpTitle'>`+this.$t("text.needsomehelp")+`</h1>
                    <div>`+this.$t("text.needsomehelp_text")+`</div>
                    <br/>
                    <div class='textContactNumber'>`+phoneLink+`
                    </div>
                    <br/>
                    <div class='row'>
                        <div class='col text-right' >
                            `+this.$t("text.needsomehelpdays")+`
                        </div>
                        <div class='col text-left'>
                            `+this.$t("text.needsomehelphours")+`
                        </div>
                    </div>
                </div>
            </div>
        `
      this.needHelpVisible=true;
      this.$nextTick(() => {
        const needHelpModalForFocus = this.$refs.needHelpModal;
        if (needHelpModalForFocus) {
          needHelpModalForFocus.focus();
        }
      });
    },
    closeNeedHelpModal(){
      this.needHelpVisible=false;
    },
    showComplaintModal() {
        document.getElementById("complaintModal").innerHTML=`
            <div class='row' style='display:block;'>
                <div class='col'></div>
                <div class='col-auto' style='text-align:left;'>
                    `+this.$t("text.footer1_complaint")+`</div>
                <div class='col'></div>
            </div>
        `
      this.complaintVisible=true;
       this.$nextTick(() => {
        const complaintModalForFocus = this.$refs.complaintModal;
        if (complaintModalForFocus) {
          complaintModalForFocus.focus();
        }
      });
    },
    closeComplaintModal(){
      this.complaintVisible=false;
    },
        
openTooltip(text) {
     console.log('Texto recebido:', text); // Deve mostrar o HTML
      this.tooltipText = text;
      this.modalVisible = true;
      
        this.$nextTick(() => {
            const keywordBody = this.$refs.keywordBody;
            if (keywordBody) {
            console.log('Conteúdo do tooltipText no DOM:', keywordBody.innerHTML);
            } else {
            console.warn('keywordBody ainda não existe no DOM');
            }
        });
 
      bus.$emit("openModal", text);
    }

  }
};
</script>
<style>
#footer {
    width:100%;
    
    padding: 20px;
    background-color: rgb(238, 238, 239);
}
.footerText {
    font-family: Arial;
    font-size: 12px;
    line-height: 1.5;
}
.btnHelp {
    padding:5px;
    padding-left:15px;
    padding-right:15px;
    background-color: #333;
    color: #fff;
    font-size: 16px;
    border-radius: 3px;
    height: 40px;
    width:150px;
    cursor: pointer;
}
.textNeedHelpTitle{
    font-weight: bold;
    font-size: 36px;
}
.textContactNumber {
    font-size: 20px;
}

a.footerLink:link,
a.footerLink:visited,
a.footerLink:hover,
a.footerLink:active {
    color: #000000;
    text-decoration:underline;
    font-weight:bold;
}
#needHelpDiv{
    background: #ffffff;
    position: fixed;
    bottom: 20px;
    right: 25px;
    z-index: 2;
    cursor: pointer;
}
.phoneLink:hover,
.phoneLink:active,
.phoneLink:link,
.phoneLink:hover {
    color: #333;
}

/* Redesigned footer (Figma: compliance-footer) */
.footerRedesigned #needHelpDiv {
    display: none !important;
}
.footerRedesigned #footer {
    box-sizing: border-box;
    padding: 40px 120px;
    background-color: #F2F2F2;
    font-family: 'Fira Sans', sans-serif;
}
.footerRedesigned #footer > .row {
    margin: 0;
}
.footerRedesigned #footer > .row > .col {
    display: none !important;
}
.footerRedesigned #footer > .row > .col-12 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    flex: 0 0 100%;
    max-width: 1200px;
    padding: 0;
}
.footerRedesigned #footer > .row > .col-12 > br,
.footerRedesigned #footer > .row > .col-12 > div > br {
    display: none;
}
.footerRedesigned .footerText {
    display: block;
    margin: 0 !important;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #6F6F6F;
}
.footerRedesigned .footerDisclosure {
    font-size: 11px;
    line-height: 150%;
}
.footerRedesigned .footerText b,
.footerRedesigned .footerText strong {
    font-weight: 700;
}
.footerRedesigned .footerText a,
.footerRedesigned .footerText a:link,
.footerRedesigned .footerText a:visited,
.footerRedesigned .footerText a:hover,
.footerRedesigned .footerText a:active {
    color: #0056B3;
    text-decoration: underline;
    font-weight: 400;
}
.footerRedesigned #footer nav .row {
    margin: 0;
    padding-top: 8px !important;
}
.footerRedesigned #footer nav ul {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    margin: 0;
    padding: 0 !important;
    list-style: none;
}
.footerRedesigned #footer nav li {
    margin: 0 !important;
}
.footerRedesigned a.footerLink:link,
.footerRedesigned a.footerLink:visited,
.footerRedesigned a.footerLink:hover,
.footerRedesigned a.footerLink:active {
    font-family: 'Fira Sans', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #0056B3;
    text-decoration: underline;
}
@media (max-width: 767.98px) {
    .footerRedesigned #footer {
        padding: 32px 16px 48px;
        background-color: #EEEEEE;
    }
}
</style>